import { render, staticRenderFns } from "./B101.vue?vue&type=template&id=eb2bda9a&scoped=true"
import script from "./B101.vue?vue&type=script&lang=js"
export * from "./B101.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=eb2bda9a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2bda9a",
  null
  
)

export default component.exports